import fondo from '../img/fond.webp';
import img from '../img/LandingPage.png';
import '../css/secciones.css'



const LandingPage = () => {
  return (
    <section className='seccionContainer' id='landingPage'>
      <img src={fondo} className='fondo' alt='fondo' />
      <div className='cardAnimation'>
        <h2 className='title'>Landing Page</h2>
      </div>
      <div className='dataContainer'>
        <img src={img} alt='landing page' />
        <div className='parrafoContainer'>
          <p className='parrafo'>
            Convierte visitas en oportunidades.
            Si buscás captar la atención de tu audiencia y generar conversiones reales,
             una Landing Page efectiva es clave. Con un diseño atractivo, responsive, contenido 
             persuasivo y llamadas a la acción estratégicas, te ayudamos a destacar online y cumplir
              tus objetivos comerciales.</p>
          <a className='info' href='https://wa.me/5491126134318?text=Hola, me gustaria consultar por una Landing Page.' target='blank' ><button>
    <span>Más información</span>
  </button></a>
        </div>
      </div>
    </section>
  )
}

export default LandingPage